import {COVERAGE_STATUS, schoolTeamOverlay} from '../../lib/schoolTeamOverlay.js'
import styles from './repVolume.module.css'

export default function SchoolTeamCoverage({record}) {
  const coverage = schoolTeamOverlay(record)
  if (!coverage) return null
  return <span className={styles.coverageOverlay} data-school-team-status={coverage.status}>
    <strong>{COVERAGE_STATUS[coverage.status] || 'Bowl coverage status unavailable'}</strong>
    <span>{[coverage.season,coverage.sport].filter(Boolean).join(' · ')}</span>
    {(coverage.scopes || []).map((scope,index) => <span key={`${scope.school}:${index}`} className={styles.coverageScope}>
      <b>{scope.school}{scope.conference ? ` · ${scope.conference}` : ''}</b>
      <span>{(scope.members || []).map(m => `${m.name} (${m.role})`).join(' + ') || 'No readable team members'}</span>
    </span>)}
    <span>{coverage.status === 'conflict' ? 'Separate recorded teams are shown; no combined team was chosen. ' : ''}Bowl coverage is separate from the CRM assignment and grants no additional access.</span>
  </span>
}
